import React from 'react'
import { Link } from 'react-router-dom'
import mundin from '../../imagenes/mundinError.png'

class Page404 extends React.Component {

    render() {

        return (
              <div className="error404">
                <img src={mundin} alt="Mundin" width="200" height="200" />
                <div className="d-inline-block">
                  <p className="codigoError">P&aacute;gina no encontrada (404)</p>
                  <p><strong>Parece que la página no existe.</strong></p>
                  <p>Pero no te pongas triste, puedes ir a la página de inicio y te ayudaremos a encontrar los mejores precios y destinos para tu próximo viaje.</p>
                </div>
                <p className="contenedorLinkInicio"><Link to='/'className="botonInicio">Ir a la p&aacute;gina de Inicio</Link></p>
              </div>
                );
    }
}

export default Page404



// WEBPACK FOOTER //
// ./src/components/Global/Page404.js